import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import heroImage from '../Images/landing-finding-banner.png';

function HeroSection() {
  return (
    <div className={css.heroSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroImg}>
          <img src={heroImage} alt="structural and civil engineers banner" />
        </div>
        <div className={css.heroInfo}>
          <h2>
            <FormattedMessage id="StructuralAndCivilEngineersPage.HeroSection.title" />
          </h2>
          <p>
            <FormattedMessage id="StructuralAndCivilEngineersPage.HeroSection.description" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
